import Subheader from './Sub_header';
import { Navbar, Nav, Container} from 'react-bootstrap'
import logo from './../images/logo.png'
import hamburger from './../images/hamburger.png'
import {useState} from 'react';

const Header = (props) => {
    
    const [isHovering, setIsHovering] = useState(false);
    function handleMouseEvent(){
        setIsHovering(true);
        props.onGray(true);
    }
    function handleMouseLeave(){
        setIsHovering(false);
        props.onGray(false);
    }

    function mobileMenuToggle(){
        setIsHovering(!isHovering);
        props.onGray(!isHovering);
    }

    return (
        <header id="header" className='fixed top-0 w-full z-50'>
            <Navbar id="header" className="white nav_bar border-gray-300 bg-white z-30 w-full aboslute p-0" expand="lg" collapseOnSelect>
                <Container id="header" className="relative z-30">
                    <a href="/"><img src={logo} alt="company logo" className="logo"/></a>
                    <div style={{cursor: "pointer"}} onClick={mobileMenuToggle} id="hamburger">
                        <img src={hamburger} alt="company logo" className="logo"/>
                    </div>
                    <Navbar.Collapse id="header">
                        <Nav id="header_title" className="py-3 h-full section spacing">
                            <div className="text-center main_nav" onMouseEnter={handleMouseEvent}>
                                <div className="text-center" style={{cursor: "pointer"}}>About TMK</div>
                                <div className="text-center" style={{cursor: "pointer"}}>Product</div>
                                <div className="text-center" style={{cursor: "pointer"}}>Business Status</div>
                                <div className="text-center" style={{cursor: "pointer"}}>Inquiry</div>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {/* sub nav */}
            <div id={isHovering ? 'gnb active' : 'gnb'} className="w-full bg-white" onMouseLeave={handleMouseLeave}>
                <Subheader/>
            </div>
        </header>
    )
}

export default Header
